<template>
  <div class="mainDiv">
    <spinner-component :loading="loading"></spinner-component>
    <error-dialog-component :model-value="this.errorDialog"></error-dialog-component>
    <v-snackbar
        v-model="publishedSuccess"
        :timeout="2000"
    >
      Opublikowano popup
      <template v-slot:action="{ attrs }">
        <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="publishedSuccess = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <v-snackbar
        v-model="savedSuccess"
        :timeout="2000"
    >
      Zapisano jako draft
      <template v-slot:action="{ attrs }">
        <v-btn
            color="blue"
            text
            v-bind="attrs"
            @click="savedSuccess = false"
        >
          Close
        </v-btn>
      </template>
    </v-snackbar>

    <image-selection-dialog :model-value="imageSelectionDialog"></image-selection-dialog>

    <v-container>
      <v-row>
        <v-col>
          <v-text-field
              v-model="popupContent.name"
              label="Nazwa popupu"
          ></v-text-field>
        </v-col>
        <v-col>
          <v-btn v-on:click="saveAsDraft">Zapisz jako draft</v-btn>
        </v-col>
        <v-col>
          <v-btn v-on:click="publishContent">Opublikuj popup</v-btn>
        </v-col>
        <v-col>
          <v-btn v-on:click="exportHtml">Eksportuj do HTML</v-btn>
        </v-col>
        <v-col>
          <router-link :to="{ name: 'popup-list' }">
            <v-btn>Powrót do listy</v-btn>
          </router-link>
        </v-col>
      </v-row>
    </v-container>
    <div class="designEdit">
      <div class="container">
        <EmailEditor editorId="popup-editor-1" ref="emailEditor" v-on:load="editorLoaded" v-on:ready="editorReady"/>
      </div>
    </div>
  </div>
</template>

<script>

import SpinnerComponent from "@/components/SpinnerComponent";
import ErrorDialogComponent from "@/components/ErrorDialogComponent";
import ImageSelectionDialog from "@/components/mails/ImageSelectionDialog";
import {popupApiClient} from "@/api/popup.api.client";
import {EmailEditor} from "vue-email-editor/src/components";

export default {
  name: 'EditPopupContentView',

  components: {
    ImageSelectionDialog,
    EmailEditor,
    SpinnerComponent,
    ErrorDialogComponent
  },

  props: {
    popupContentProp: Object
  },

  data() {
    return {
      popupContent: {},

      // MISC
      loading: false,
      errorDialog: {
        errorMessage: "",
        visible: false
      },
      publishedSuccess: false,
      savedSuccess: false,
      imageSelectionDialog: {
        visible: false,
        doneCallback: undefined
      }
    }
  },

  created() {
    if (this.popupContentProp) {
      this.popupContent = this.popupContentProp;
    } else {
      this.popupContent = {
        name: '',
        design: null,
        published: false
      };
    }
    this.loading = true;
  },

  methods: {
    editorReady() {
      this.loading = false;
      this.$refs.emailEditor.editor.registerCallback('image', (data, done) => {
        this.imageSelectionDialog.doneCallback = done;
        this.imageSelectionDialog.visible = true;
      })
    },

    editorLoaded() {
      if (this.popupContent.design) {
        this.$refs.emailEditor.editor.loadDesign(this.popupContent.design);
      }
    },

    exportHtml() {
      this.$refs.emailEditor.editor.exportHtml((data) => {
        console.log('exportHtml', data);
      });
    },

    saveAsDraft() {
      this.$refs.emailEditor.editor.exportHtml((content) => {
            this.loading = true;
            this.popupContent.design = content.design;
            this.popupContent.html = content.html;
            console.log(this.popupContent)
            if (this.popupContent.id) {
              this.updatePopup()
            } else {
              this.createPopup()
            }
          }
      )
    },

    createPopup() {
      popupApiClient.createPopupContent(this.popupContent, (response) => {
            this.popupContent.id = response.data.id;
            this.savedSuccess = true;
          },
          () => {
            this.errorDialog.visible = true;
            this.errorDialog.errorMessage = "Błąd podczas tworzenia popupu!";
          },
          () => this.loading = false
      );
    },

    updatePopup() {
      popupApiClient.updatePopupContent(this.popupContent.id, this.popupContent, () => {
            this.savedSuccess = true;
          },
          () => {
            this.errorDialog.visible = true;
            this.errorDialog.errorMessage = "Błąd podczas zapisywania popupu!";
          },
          () => this.loading = false
      );
    },

    publishContent() {
      this.loading = true;
      this.$refs.emailEditor.editor.exportHtml((content) => {
            this.loading = true;
            this.popupContent.design = content.design;
            this.popupContent.html = content.html;
            if (this.popupContent.id) {
              this.updatePopup()
            } else {
              this.createPopup()
            }
          }
      )
      popupApiClient.publishPopupContent(this.popupContent.id,
          () => {
            this.publishedSuccess = true;
          },
          () => {
            this.errorDialog.visible = true;
            this.errorDialog.errorMessage = "Błąd podczas publikacji popupu!";
          },
          () => this.loading = false
      );
    }
  }
};
</script>
<style>
html, body {
  margin: 0;
  padding: 0;
  height: 100%;
  font-family: Arial, "Helvetica Neue", Helvetica, sans-serif;
}

.mainDiv {
  height: 100vh;
  display: flex;
  flex-direction: column;
}

#app, .mainDiv .designEdit {
  height: 100%;
  flex: 1;
}

.mainDiv .designEdit .container {
  display: flex;
  flex-direction: column;
  position: relative;
  height: 100%;
  width: 100%;
  flex: 1;
}

.mainDiv .designEdit .container >>> .email-editor {
  flex: 1;
  width: 100%;
  min-height: 600px;
}

#bar {
  flex: 1;
  background-color: #40B883;
  color: #FFF;
  padding: 10px;
  display: flex;
  max-height: 40px;
}

#bar h1 {
  flex: 1;
  font-size: 16px;
  text-align: left;
}

#bar button {
  flex: 1;
  padding: 10px;
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  background-color: #000;
  color: #FFF;
  border: 0px;
  max-width: 150px;
  cursor: pointer;
}

#bar a {
  flex: 1;
  padding: 10px;
  margin-left: 10px;
  font-size: 14px;
  font-weight: bold;
  color: #fff;
  border: 0px;
  cursor: pointer;
  text-align: right;
  text-decoration: none;
  line-height: 160%;
}
</style> 